//region :: Imports ::
import {IMsalContext} from '@azure/msal-react';
import MAccessTokenProvider from '../Toolkit/Api/AccessTokenProvider';

//endregion;

/** */
class TrafficManagementAccessTokenProvider extends MAccessTokenProvider {

    /** */
    public constructor(msalContext: IMsalContext) {
        super(msalContext, ['api://b62faec3-9c5e-4c89-aaff-5bc58c4c290b/user_impersonation']);
    }

}

export default TrafficManagementAccessTokenProvider;
